export const homePage = {
    urlVideoException: ['https://mp4.ina.fr/', 'https://www.youtube-nocookie.com/'], // url exception for play video url who is not know by js-video-url-parser
    isProgressionEnable: true,
    concepts: ['Anglais', 'Espagnol']
};
